import { LocalDate } from '../../core/model/local-date';
import { ModelBase } from '../../core/model/model-base';
import { Money } from '../../core/model/money';
import {
  PaymentNoticeDeliveryStatus,
  PaymentNoticeDeliveryStatusToString,
  ReminderDeliveryMethod,
  ReminderDeliveryMethodToString,
} from './const/enum';

export class AmortizationPlanPaymentNoticeListItem extends ModelBase {
  sequenceNumber?: number;
  ocrNumber: string;
  amortizationPlanId: string;
  amortizationPlanNumber: number;
  companyId: string;
  companyName: string;
  debtorContactId: string;
  debtorContactName: string;
  dueDate: LocalDate;
  amount: Money;
  remainingAmount: Money;
  createdDate: Date;
  sentDate?: Date;
  deliveryMethod: ReminderDeliveryMethod;
  deliveryAddress: string;
  latestDeliveryStatus?: PaymentNoticeDeliveryStatus;
  latestDeliveryCreatedDate?: Date;
  latestDeliveryLastAttemptedAt?: Date;
  latestDeliveryAttemptCount: number;

  get deliveryMethodCaption(): string {
    return typeof this.deliveryMethod === 'number' ? ReminderDeliveryMethodToString(this.deliveryMethod) : null;
  }

  get latestDeliveryStatusCaption(): string {
    return typeof this.latestDeliveryStatus === 'number'
      ? PaymentNoticeDeliveryStatusToString(this.latestDeliveryStatus)
      : 'AMORTIZATION_PLAN.PAYMENT_NOTICE.DELIVERY_STATUS_NOT_REQUESTED';
  }
}
